var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"width":"1200px"},on:{"cancel":_vm.cancelDialog}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("云账号配置向导")]),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('cloud-account-setup-guide')],1),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v(_vm._s(''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }